import React, {useEffect, useState} from "react";
import api from "../api";

// Anchors are linked to help articles/videos from the admin panel ("مدیریت محتوی" → ویرایش محتوا → بخش‌های برنامه).
// The map is fetched once per session and shared by every hint.
let anchorsPromise = null;
const loadAnchors = () => {
    if (!anchorsPromise) {
        anchorsPromise = api.get("/help-center/anchors")
            .then(({data}) => data?.data || {})
            .catch(() => {
                anchorsPromise = null;
                return {};
            });
    }
    return anchorsPromise;
};

const helpUrl = (item) => `${window.location.origin}${window.location.pathname}#/help?view=${item.type}&id=${encodeURIComponent(item.id)}`;

/**
 * Small "i" in a circle shown next to an element that has linked help content.
 * Renders nothing when no article/video is linked to `anchor`; click opens the content in a new tab.
 */
export default function HelpHint({anchor, className = ""}) {
    const [item, setItem] = useState(null);

    useEffect(() => {
        let active = true;
        loadAnchors().then((map) => {
            if (active) setItem(map[anchor] || null);
        });
        return () => {
            active = false;
        };
    }, [anchor]);

    if (!item) return null;
    return (
        <a
            href={helpUrl(item)}
            target="_blank"
            rel="noopener noreferrer"
            title={item.title}
            aria-label={item.title}
            onClick={(event) => event.stopPropagation()}
            className={`help-hint inline-flex align-items-center justify-content-center border-circle no-underline ${className}`}
            style={{
                width: "1.15rem",
                height: "1.15rem",
                border: "1.5px solid #E6511C",
                color: "#E6511C",
                fontFamily: "Georgia, 'Times New Roman', serif",
                fontStyle: "italic",
                fontWeight: 700,
                fontSize: "0.72rem",
                lineHeight: 1,
                paddingBottom: "1px",
                boxSizing: "border-box",
                background: "rgba(230, 81, 28, 0.08)",
                transition: "background 0.15s, color 0.15s, transform 0.15s",
            }}
            onMouseEnter={(event) => Object.assign(event.currentTarget.style, {background: "#E6511C", color: "#fff", transform: "scale(1.1)"})}
            onMouseLeave={(event) => Object.assign(event.currentTarget.style, {background: "rgba(230, 81, 28, 0.08)", color: "#E6511C", transform: "none"})}
        >
            i
        </a>
    );
}
